/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ProfilePlusPage = lazyLoad(
  () => import('./index'),
  module => module.ProfilePlusPage,
);
